import React from "react";
import { Link } from "react-router-dom";
import ProductCardDetails from "./ProductCardDetails";
import classes from "./ProductCard.module.css";
import Image from "../../common/image";

const ProductCard = (props) => {
  return (
    <Link
      className={classes["product_card"]}
      to={`/product/${props.catId}/${props.prodId}`}
    >
      <figure>
        <Image
          src={props.prodThumbnail}
          alt={props.prodTitle}
          className={classes["product_card-images"]}
        />
        <ProductCardDetails
          prodTitle={props.prodTitle}
          prodPrice={props.prodPrice}
          prodOldPrice={props.prodOldPrice}
          prodDiscountPct={props.prodDiscountPct}
          prodRating={props.prodRating}
        />
      </figure>
    </Link>
  );
};

export default ProductCard;
